import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box as ResizableBox } from '../Resizeable/styled';

import allWatchlistSlice, { selectors } from './slice';

import Header from './Header';
import CompanyWatchlist from './CompanyWatchlist';
import ListWatchlist from './ListWatchlist';
import Orderbook from './Orderbook';
import TableWatchlist from './CompanyWatchlist/TableWatchlist';

function Allwatchlist() {
  const dispatch = useDispatch();
  const { watchlistId, showList } = useSelector(selectors);

  const [addSymbol, setAddSymbol] = useState(false);

  const [resizeableHeight, setResizeableHeight] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);

  useEffect(() => {
    const resizeable = document.getElementsByClassName('sw-watchlist');
    if (resizeable.length) {
      setResizeableHeight(resizeable[0].clientHeight);
    }
    setWindowHeight(window.innerHeight);
  }, []);

  useEffect(() => {
    return () => {
      dispatch(
        allWatchlistSlice.actions.toggleViewType({ listType: 'company' }),
      );
    };
  }, [dispatch]);

  return (
    <>
      {/* @ts-ignore */}
      <ResizableBox
        className="sw-watchlist"
        defaultSize={{ height: `50%`, width: '100%' }}
        maxHeight={windowHeight - 40}
        minHeight={40}
        onResizeStop={(e, direction, ref, d) => {
          const h = resizeableHeight + d.height;
          setResizeableHeight(h);
        }}
      >
        <>
          <Header isAddSymbol={addSymbol} setAddSymbol={setAddSymbol} />
          {showList === 'company' && (
            <TableWatchlist
              watchlistId={watchlistId}
              setAddSymbol={setAddSymbol}
            />
          )}
          {showList === 'saved' && <ListWatchlist watchlistId={watchlistId} />}
        </>
      </ResizableBox>
      <div
        style={{
          height: `calc(${windowHeight}px - ${resizeableHeight}px)`,
        }}
      >
        <Orderbook />
      </div>
    </>
  );
}

export default Allwatchlist;
